import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes, FilterType,
} from 'app/enums/common.enums'
import {
    ContractCurrency, LaneFeesStatus, ProductType,
} from 'app/enums/label.enums'

import {
    LaneFeesFilterRequestResponse,
} from '../../LaneFees/LaneFees.types'

const config: SkyNetTableConfig<keyof LaneFeesFilterRequestResponse> = {
    name: 'laneFeesExpireSoon',
    tabs: [{
        name: 'Expire Soon',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'laneFeesNumber',
                labelKey: 'LaneFeesView.lfNumber',
                width: '130px',
                reduced: true,
            },
            {
                name: 'laneFeesStatus',
                labelKey: 'LaneOpsInformationDto.laneStatus',
                filterField: 'laneFeesStatus',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: LaneFeesStatus,
                width: '130px',
                reduced: true,
            },
            {
                name: 'laneGroupNumber',
                labelKey: 'LaneFeesView.lgNumber',
                filterField: 'laneGroupNumber',
                filterType: FilterType.Array,
                width: '130px',
                reduced: true,
            },
            {
                name: 'contractBasisNumber',
                labelKey: 'LaneFeesView.cbNumber',
                filterField: 'contractBasisNumber',
                filterType: FilterType.Array,
                width: '130px',
                reduced: true,
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'AccountLane.pricingAccount',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
                width: '300px',
            },
            {
                name: 'customerQuotationLocationName',
                labelKey: 'ContractBasisFlat.customerQuotationLocationName',
                filterField: 'customerQuotationLocationName',
                filterType: FilterType.Array,
                width: '400px',
            },
            {
                name: 'contractBasisCurrency',
                labelKey: 'LaneOpsInformationDto.currency',
                filterField: 'contractBasisCurrency',
                filterType: FilterType.Array,
                allowedValuesEnum: ContractCurrency,
                width: '130px',
            },
            {
                name: 'originAirportsIataCode',
                componentName: 'List',
                labelKey: 'AccountLane.originAirport',
                filterField: 'originAirportsIataCode',
                filterType: FilterType.Array,
                width: '200px',
            },
            {
                name: 'destinationAirportsIataCode',
                componentName: 'List',
                labelKey: 'AccountLane.destinationAirport',
                filterField: 'destinationAirportsIataCode',
                filterType: FilterType.Array,
                width: '200px',
            },
            {
                name: 'validFrom',
                labelKey: 'LaneFees.validFrom',
                filterField: 'validFrom',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
                width: '130px',
            },
            {
                name: 'validTo',
                labelKey: 'LaneFees.validTo',
                filterField: 'validTo',
                filterType: FilterType.DateRange,
                componentName: 'LaneDateEnriched',
                width: '130px',
            },
            {
                name: 'allBaseLeaseProductType',
                labelKey: 'LaneFees.containerTypes',
                allowedValuesEnum: ProductType,
                componentName: 'EnumList',
                width: '300px',
                sorting: false,
            },
            {
                name: 'rentalDays',
                labelKey: 'LaneFees.rentalDays',
                width: '130px',
            },
            {
                name: 'logisticsDays',
                labelKey: 'LaneFees.logisticsDays',
                width: '130px',
            },

        ],
    }],
}

export default config
